export default __webpack_public_path__ + "static/media/one.3a35ee8d.jpeg";